<template>
    <div>
        <div v-if="$meta.features.tenants.fixflo">
            <h4 class="subtitle is-6 mb-5">
                Use the form below to log a fault with your property.
            </h4>

            <FixfloLettingsIframe />
        </div>

        <div v-else-if="$meta.features.tenants.report_repair_contact_details">
            <p>
                To request a repair, please email
                <a :href="`mailto:${$meta.email_address}`">{{ $meta.email_address }}</a><template v-if="$meta.phone_number"> or phone {{ $meta.phone_number }}</template>.
            </p>
            <p>
                When emailing us, please include any relevant information and photos.
            </p>
        </div>
    </div>
</template>

<script>
import FixfloLettingsIframe from '../components/FixfloLettingsIframe.vue';

export default {
    components: {
        FixfloLettingsIframe,
    },
};
</script>
